import { MSG_ERROR_REQUIRED_FIELD } from '@/common/constants';
import * as yup from 'yup';

export const AuthSchema = yup.object().shape({
  username: yup.string().required(MSG_ERROR_REQUIRED_FIELD),
  password: yup.string().required(MSG_ERROR_REQUIRED_FIELD),
});
